import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RefreshCw, X } from "lucide-react";

/**
 * SwUpdateToast — listens for the 'orio:sw-update-ready' event dispatched from
 * index.js when a new service worker version is ready to activate. Shows a
 * warm ORIO toast so the user can update in one tap.
 */
export default function SwUpdateToast() {
  const [reg, setReg] = useState(null);

  useEffect(() => {
    const onReady = (e) => setReg(e.detail?.reg || null);
    window.addEventListener("orio:sw-update-ready", onReady);
    return () => window.removeEventListener("orio:sw-update-ready", onReady);
  }, []);

  const activate = () => {
    try {
      reg?.waiting?.postMessage({ type: "SKIP_WAITING" });
    } catch { /* ignore */ }
    // The controllerchange handler in index.js will reload the page.
  };

  return (
    <AnimatePresence>
      {reg && (
        <motion.div
          data-testid="sw-update-toast"
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ type: "spring", stiffness: 320, damping: 26 }}
          className="fixed bottom-24 sm:bottom-8 left-1/2 -translate-x-1/2 z-[600]
                     inline-flex items-center gap-3 px-3.5 py-2.5 rounded-full bg-white border"
          style={{
            borderColor: "#F0EBE3",
            boxShadow: "0 20px 40px -12px rgba(0,0,0,0.18), 0 4px 10px -4px rgba(0,0,0,0.06)",
          }}
        >
          <div
            className="h-8 w-8 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background: "linear-gradient(135deg, #FF7A1A 0%, #FF5C2A 100%)",
              boxShadow: "0 6px 14px -4px rgba(255,92,42,0.55)",
            }}
          >
            <RefreshCw className="h-4 w-4" />
          </div>
          <div className="min-w-0">
            <div className="text-[12px] font-semibold text-[#1A1A1A] leading-tight">
              Nuova versione disponibile
            </div>
            <div className="text-[11px] text-[#7A7A7A] leading-tight">
              Aggiorna per avere le ultime novità
            </div>
          </div>
          <button
            data-testid="sw-update-cta"
            onClick={activate}
            className="ml-1 px-3 py-1.5 rounded-full text-[11.5px] font-semibold text-white active:scale-[0.97] transition-transform"
            style={{
              background: "linear-gradient(135deg, #FF7A1A 0%, #FF5C2A 100%)",
            }}
          >
            Aggiorna
          </button>
          <button
            data-testid="sw-update-close"
            onClick={() => setReg(null)}
            className="h-7 w-7 rounded-full flex items-center justify-center text-[#7A7A7A] hover:bg-[#F4EFE6]"
            aria-label="Chiudi"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
